import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { validateCoupon, clearCoupon, updateCartTotals } from '../../../redux/actions/CartActions';
import { Button, Link, Typography, TextField } from "@mui/material";
import './CouponSection.scss';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';

const CouponSection = () => {
  const dispatch = useDispatch();
  const [couponCode, setCouponCode] = useState('');
  const [showCouponInput, setShowCouponInput] = useState(false);
  
  const { 
    coupon, 
    loading, 
    error 
  } = useSelector(state => state.cart);

  const handleCouponSubmit = () => {
    if (couponCode.trim()) {
      dispatch(validateCoupon(couponCode));
    }
  };

  const handleCancelCoupon = () => {
    setShowCouponInput(false);
    setCouponCode('');
    dispatch(clearCoupon());
    dispatch(updateCartTotals());
  };

  return (
    <div className="coupon-section">
      {!coupon ? (
        !showCouponInput ? (
        <div className="coupon-prompt">
          <Typography>Do you have a Coupon?</Typography>
          <Link 
            component="button"
            onClick={() => setShowCouponInput(true)}
            className="apply-link"
          >
            Apply
          </Link>
        </div>
        ) : (
          <div className="coupon-input-container">
            <TextField
              size="small"
              value={couponCode}
              onChange={(e) => setCouponCode(e.target.value)}
              placeholder="Enter coupon code"
              error={!!error}
              helperText={error}
              disabled={loading}
              className="coupon-input"
            />
          <div className="button-group">
            <Button 
              onClick={handleCouponSubmit} 
              variant="contained" 
              size="small"
              disabled={loading}
              className="apply-button"
            >
              {loading ? 'Applying...' : 'Apply'}
            </Button>
            <Button 
              onClick={handleCancelCoupon} 
              variant="text" 
              size="small"
              disabled={loading}
              className="cancel-button"
            >
              Cancel
            </Button>
          </div>
          </div>
        )
      ) : (
        <div className="applied-coupon">
        <div className="coupon-info">
          <Typography variant="body2" className="success-message">
            Coupon {coupon.code} applied successfully!
          </Typography>
          <Typography variant="body2" className="discount-info">
            {`($${coupon.discount} off)`}
          </Typography>
        </div>
          <Button 
            onClick={handleCancelCoupon} 
            variant="text" 
            size="small"
            className="remove-button"
          >
            <DeleteOutlinedIcon/>
          </Button>
        </div>
      )}
    </div>
  );
};

export default CouponSection;
